// Bojan Nikolic <bojan@bnikolic.co.uk> 2019
import React, { Component } from "react";
import Spinner  from "react-bootstrap/Spinner";

// A result from the expert system -- no input is solited
export default class EStatus extends Component {

  render() {
    return (this.props.loading ? <div>
	    <Spinner animation="border" >
	    </Spinner>
	    </div>
	    : <div>
	    <span> Ready </span>
	    </div>
	   );
  }
}

